import * as React from 'react';
import { Attributes } from '../types';
import Text, { TextProps } from '../Text/Text';

export interface FormInputLabelProps extends TextProps {}

const FormInputLabel: React.ForwardRefRenderFunction<HTMLInputElement, Attributes<HTMLInputElement, FormInputLabelProps>> = (props, ref) => {
  return (
    <Text { ...props }
        basis="none"
        className="FormInput__label"
        grow
        ref={ ref }
        size="x2" />
  );
};

export default React.forwardRef(FormInputLabel);
